module.exports = __webpack_public_path__ + "static/img/leiniao_verify_icon.a280d043.png";